import { picoapp } from 'picoapp'

import slaterWelcome from '@/components/slater-welcome.js'

import accordion from '@/components/accordion.js';
import accountLogin from '@/components/accountLogin.js'
import cartDrawer from '@/components/cartDrawer.js'
import cartDrawerItem from '@/components/cartDrawerItem.js'
import desktopNav from '@/components/desktopNav.js';
import header from '@/components/header.js'
import homeFeatureProductSlider from '@/components/home-feature-product-slider.js';
import mobileMenu from '@/components/mobileMenu.js';
import priceUpdater from '@/components/priceUpdater.js';
import product from '@/components/product.js'
import productCounter from '@/components/product-counter.js'
import productForm from '@/components/productForm.js';
import productSelection from '@/components/product-selection.js'
import swatch from '@/components/swatch.js';
import toggleSearch from '@/components/toggleSearch.js';
import searchResults from '@/components/searchResults.js';
import bindImage from '@/components/bindImage.js';

const state = {
  cartOpen: false
} 

const components = {
  accordion,
  accountLogin,
  cartDrawer,
  cartDrawerItem,
  desktopNav,
  header,
  homeFeatureProductSlider,
  mobileMenu,
  priceUpdater,
  product,
  productCounter,
  productForm,
  productSelection,
  slaterWelcome,
  swatch,
  toggleSearch,
  bindImage
}

export default picoapp(components, state)
